import { render } from "./AppSkeleton.vue?vue&type=template&id=533c07ea&scoped=true"
import script from "./AppSkeleton.vue?vue&type=script&lang=js"
export * from "./AppSkeleton.vue?vue&type=script&lang=js"

import "./AppSkeleton.vue?vue&type=style&index=0&id=533c07ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533c07ea"]])

export default __exports__